import { type ReactNode } from "react";
import { formatDateDDMMYYYY } from "helpers/date";
import { formatAddress } from "helpers/forms/address";
import { formatDirectorName } from "helpers/forms/director";
import { type AddressData } from "services/address/addressTypes";
import { type DirectorData } from "services/director/directorTypes";

type Formatter = (director: DirectorData, address?: AddressData) => ReactNode | undefined;

export const DIRECTOR_FIELDS_LIST: Array<{
  label: string;
  formatter: Formatter;
}> = [
  {
    label: "Full name",
    formatter: formatDirectorName,
  },
  {
    label: "Date of birth",
    formatter: (director: DirectorData): ReactNode => {
      return director.dob ? formatDateDDMMYYYY(director.dob) : "";
    },
  },
  {
    label: "Nationality",
    formatter: (director: DirectorData): ReactNode => {
      return director.nationality;
    },
  },
  {
    label: "Address",
    formatter: (_0: DirectorData, address?: AddressData): ReactNode | undefined => {
      return address ? formatAddress(address) : undefined;
    },
  },
];
